module.exports = __webpack_public_path__ + "media/assets/images/blog/customerize_7239-small-e8edd1c45ff13404d70631a4198838a8.jpg";